import script from "./UserLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLayout.vue?vue&type=script&lang=ts&setup=true"

import "./UserLayout.vue?vue&type=style&index=0&id=b5beccca&lang=scss&scoped=true"
import "./UserLayout.vue?vue&type=style&index=1&id=b5beccca&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5beccca"]])

export default __exports__